import { render, staticRenderFns } from "./daisy-message-preview-modal.component.vue?vue&type=template&id=e587df86&scoped=true&"
import script from "./daisy-message-preview-modal.component.vue?vue&type=script&lang=ts&"
export * from "./daisy-message-preview-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./daisy-message-preview-modal.component.vue?vue&type=style&index=0&id=e587df86&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e587df86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VCard,VIcon})
